/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJaneStreetV1PfofJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JANE_STREET_V1_PFOF_JOB_EVENT_ENTITY_NAME = 'exc.jane_street.v1.PfofJobEvent';
export const excJaneStreetV1PfofJobEventEntity = new schema.Entity<ExcJaneStreetV1PfofJobEvent>(EXC_JANE_STREET_V1_PFOF_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcJaneStreetV1PfofJobEvent) => `${entity.metadata?.eventId}` });

